module.exports = __webpack_public_path__ + "static/adarsh-bbb51829d9533f88075115e9dacb40a1.png";